import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import LazyLoad from "react-lazyload";

import AmenityImg1 from "./../../assets/img/collection-inner/amenity-img1.png";
import AmenityImg2 from "./../../assets/img/collection-inner/amenity-img2.png";

import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function CollectionInnerAmenities({ amenities }) {
    
  const amenitiesslides = amenities.slides ? JSON.parse(amenities.slides) : [];

  return ( 
      <section className="collection-inner-amenities-sec">
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={12}>
              <div className="heading-div">
                <h2 className="common-head darkGrey" data-aos="fade-up">
                  {amenities.title}
                </h2>
                <p className="common-para" data-aos="fade-up">
                  {amenities.description} 
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="amenity-swiper-container">
          <Row>
            <Col md={12}>
              <Swiper
                modules={[Navigation]}
                navigation={true}
                spaceBetween={60}
                slidesPerView={1}
                speed={1000}
                grabCursor={true}
                draggable={true}
                loop={true}
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  992: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  1024: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  1280: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  1920: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                  3840: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                  },
                }}
              >
                {amenitiesslides.map((amenitiesslide, index) => {             
                  if (index % 2 === 0) {
                    return (
                      <SwiperSlide key={index}>
                        <div className="amenity-slide-div">
                          <Row>                          
                            <Col md={6}>
                              {/* <LazyLoad> */}
                                <img
                                  src={`${apiUrl.apiUrl}/${amenitiesslides[index].amenity_image}`}
                                  className="img-fluid"
                                  alt={amenitiesslides[index].amenity_title}
                                />
                              {/* </LazyLoad> */}
                              <div className="amenity-slide-content">
                                <p className="common-para">
                                  {amenitiesslides[index].amenity_title}
                                </p>
                              </div>
                            </Col>
                          
                            {amenitiesslides[index + 1] && (
                              <Col md={6}>
                                {/* <LazyLoad> */}
                                  <img
                                    src={`${apiUrl.apiUrl}/${
                                      amenitiesslides[index + 1].amenity_image
                                    }`}
                                    className="img-fluid"
                                    alt={
                                      amenitiesslides[index + 1].amenity_title
                                    }
                                  />
                                {/* </LazyLoad> */}
                                <div className="amenity-slide-content">
                                  <p className="common-para">
                                    {amenitiesslides[index + 1].amenity_title}
                                  </p>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </div>
                      </SwiperSlide>
                    );
                  }

                  return null; 
                })}                
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}

export default CollectionInnerAmenities;
